"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMileageOrPerDiem = exports.isAtLeastReviewed = void 0;
const models_1 = require("../models");
exports.isAtLeastReviewed = (status) => status === models_1.ExpenseStatusEnum.REVIEWED || status === models_1.ExpenseStatusEnum.PAID || status === models_1.ExpenseStatusEnum.DONE;
exports.isMileageOrPerDiem = (expense) => [models_1.ExpenseKindEnum.MILEAGE, models_1.ExpenseKindEnum.PER_DIEM].includes(expense.kind);
